<template>
  <div class="form-group">
    <LabelText :label-for="name">
      {{ label }}
    </LabelText>
    <div
      class="px-0"
      :class="`col-${col} d-flex align-items-center`">
      <slot name="fieldPrepend" />
      <b-form-select
        :id="name"
        :value="_value"
        :name="name"
        :placeholder="placeholder"
        :options="optionsWithPlaceholder"
        :disabled="disabled"
        :class="selectClass"
        v-on="$listeners" />
    </div>
    <BaseErrorMessage
      :errors="errors"
      :class="errorMessageClass" />
  </div>
</template>

<script>
import LabelText from '@/components/parts/LabelText.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  name: 'BaseTextFieldGroup',
  components: {
    LabelText,
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    selectClass: {
      type: String,
      default: undefined
    },
    errorMessageClass: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    hasPlaceholder() {
      return this.placeholder != null
    },
    placeholderOption() {
      return { value: null, text: this.placeholder, disabled: true }
    },
    optionsWithPlaceholder() {
      if (this.hasPlaceholder) {
        return [this.placeholderOption, ...this.options]
      }
      return this.options
    }
  },
}
</script>

<style>

</style>